define('views/components/cd_product/cd_product_list',['require','views/base/list_view','views/components/cd_product/cd_product','text!templates/components/cd_product/cd_product_list.html'],function(require){

    var BaseListView = require('views/base/list_view');
    var ChildView = require('views/components/cd_product/cd_product');

    var temp = require("text!templates/components/cd_product/cd_product_list.html");
    return BaseListView.extend({
        template: _.template(temp),
        childView: ChildView
    });
});

